var checkout = {
    token : '',
    host: '',
    afiliate: '',
    ip: '',
    meeting: {status:false, ini:'', fin:'', date:''},
    billing : {
        "name": "",
        "lastaname": "",
        "email": "",
        "phone": "",
        "city": "",
        "address": "",
        "countryCode": "",
        "documentNumber": ""
    },
    sendOrder : function(object)
    {

        checkout.order({
            publicationId:$(object).data('publicationid'),
            itemId:$(object).data('tipsid'),
            quantity:$(object).data('quantity'),
            upsellId:$(object).data('upsellid'),
            typeOrder:$(object).data('typeorder'),
            gateway:$(object).data('gateway'),
            upsellPublicationContentId:$(object).data('upsellpublicationcontentid'),
            upsellPaymentReference:$(object).data('upsellpaymentreference'),
            idBtn: $(object).attr('id')
        });
        
    },
    test: function()
    {
        
    },
    order: function(object)
    {
        object.params = {
            ip: checkout.ip, 
            upsellPublicationContentId : object.upsellPublicationContentId,
            upsellPaymentReference : object.upsellPaymentReference,
            code: object.params.code,
            userId: object.params.userId
        };
        var idBtn = object.idBtn;
        var params = { 
            "publication": {
                "id" : object.publicationId
            },
            "items": [
                {
                  "id": object.itemId,
                  "name": "",
                  "quantity": object.quantity,
                  "amount": "",
                  "currency": ""
                }
              ],
            "payment" : {
                "type": "CC",
                "method": '',
                "gateway": object.gateway,
                "detail": {
                    "model" : 0, //0pago, 1:suscripcion
                    "modality" : 1
                },
            },
            "upsellId" : object.upsellId,
            "typeOrder" : object.typeOrder,
            "billing": checkout.billing,
            "reference": "",
            "currency": "",
            "redirectUri": "",
            "params" : object.params
          };
          var textBtnOrder = $('#'+idBtn).text();
          $('#'+idBtn).text('Procesando..');
          $('#'+idBtn).attr('disabled', true);
          $.ajax({
            url:  checkout.host + 'es/checkout/order',
            data: JSON.stringify(params),
            type: 'POST',
            dataType: "json",
            headers: {
                "Authorization": checkout.token,
                "Content-Type": "application/json"
            },
            success : function(data) {
                if (data.success == true) {
                    Swal.fire({
                        type: 'success',
                        title: 'Ok...',
                        text: 'Su transacción se proceso correctamente',
                      })
                      $('#offertOneModal').modal('hide');
                      $('#offertTwoModal').modal('hide');
                      setInterval(function() {
                        location.reload();
                      }, 3000);
                } else {
                    $('#'+idBtn).text(textBtnOrder);
                    $('#'+idBtn).attr('disabled', false);
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: data.message,
                      })
                }
            },
            error : function(xhr, status) {
                Swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: 'Se produjo un error, intentalo en unos minutos.',
                  })
            }
        });
    },
    checkout: function(publicationId, itemId, type, quantity, priceId, recurring, month, editAmountRecurring, idText)
    {
        /*if(auth.params.login == false) {
            $('#loginModal').modal('show');
            auth.functionContinue = 'checkout';
            auth.continue = true;
            auth.extraParams = {
                publicationId : publicationId, 
                itemId : itemId, 
                type : type, 
                quantity : quantity, 
                priceId : priceId, 
                recurring : recurring, 
                month : month
            };
            return false;
        }*/
        var amount = '';
        if(editAmountRecurring == 1) {
            var min = $('#'+idText).data('min');
            console.log(min);
            if($('#'+idText).val() < min
            || isNaN($('#'+idText).val())) {
                Swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: 'Monto debe ser mayor a ' + min,
                  })
                  return false;
            }
            amount = $('#'+idText).val() * month;
        }
        var params = {
            "product": {
                "id" : publicationId,
                "type" : type,
            },
            "items": [
                {
                  "id": itemId,
                  "name": "",
                  "quantity": quantity,
                  "amount": amount,
                  "currency": "",
                  "priceId": priceId
                }
              ],
            "sesionDirect" : true, 
            "billing": checkout.billing,
            "reference": "",
            "currency": "",
            "afiliate": checkout.afiliate,
            "redirectUri": "",
            "recurring" : {
                "recurring" : recurring,
                "month" : month
            }
          };
          if(checkout.meeting.status) {
              params.product.meeting = checkout.meeting;
          } 
            console.log(checkout.token)
            $.ajax({
                url:  '/es/checkout/link',
                data: JSON.stringify(params),
                type: 'POST',
                dataType: "json",
                headers: {
                    "Authorization": checkout.token,
                    "Content-Type": "application/json"
                },
                success : function(data) {
                    $("#form-login").find(".btn-l-primary").removeClass("block-btn-load");
                    if (data.success == true) {
                        location.href = data.data.url;
                    } else {
                        var messages = [];
                        var i = 0;
                        $.each(data.messages, function( index, value ) {
                            messages[i] = value;
                            i++;
                        });
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: messages.join(', '),
                        })
                    }
                },
                error : function(xhr, status) {
                    
                }
            })
    }
}
